const floatRoundDown = (float: number): number => {
  return Math.floor(float * 1e2) / 1e2
}

export default floatRoundDown
